export const marketingNe: Record<string, string> = {
  "Start your business account": "आफ्नो व्यवसाय खाता सुरु गर्नुहोस्",
  "Join Mero Perks free": "निःशुल्क मेरो पर्क्समा जोडिनुहोस्",
  "Mero Perks · More places. Brighter days.": "मेरो पर्क्स · धेरै ठाउँ। उज्याला दिन।",
  Highlights: "मुख्य विशेषताहरू",
  "Designed for real life": "वास्तविक जीवनका लागि बनाइएको",
  "Powerful where it matters. Simple where it should be.":
    "जहाँ आवश्यक छ त्यहाँ शक्तिशाली। जहाँ हुनुपर्छ त्यहाँ सरल।",
  "How it comes together": "यो कसरी एकसाथ काम गर्छ",
  "A clear path from first step to lasting value.":
    "पहिलो कदमदेखि दीर्घकालीन मूल्यसम्मको स्पष्ट बाटो।",
  "Ready when you are": "तपाईं तयार हुँदा हामी पनि तयार",
  "Build loyalty around your business.": "आफ्नो व्यवसाय वरिपरि वफादारी निर्माण गर्नुहोस्।",
  "Become a partner": "साझेदार बन्नुहोस्",
  "Create your free account": "आफ्नो निःशुल्क खाता बनाउनुहोस्",
  "Make the next visit count.": "अर्को भ्रमणलाई अर्थपूर्ण बनाउनुहोस्।",
  "Clear by design": "सुरुदेखि नै स्पष्ट",
  "See what you earned, where it works, and when it is ready to use.":
    "तपाईंले के कमाउनुभयो, कहाँ चल्छ र कहिले प्रयोग गर्न तयार हुन्छ स्पष्ट हेर्नुहोस्।",
  "Secure at checkout": "चेकआउटमा सुरक्षित",
  "Short-lived QR codes protect membership and reward redemption.":
    "छोटो समयका लागि मान्य क्यूआरले सदस्यता र पुरस्कार रिडेम्प्सन सुरक्षित राख्छ।",
  "Always connected": "सधैं जोडिएको",
  "Web and mobile experiences stay in sync after earning or redemption.":
    "कमाइ वा रिडेम्प्सनपछि वेब र मोबाइल अनुभव एकसाथ अद्यावधिक रहन्छन्।",
  "Rules you control": "तपाईंको नियन्त्रणका नियम",
  "Set earning and redemption value around your real margins and goals.":
    "आफ्नो वास्तविक नाफा सीमा र लक्ष्यअनुसार कमाइ तथा रिडेम्प्सन मूल्य तय गर्नुहोस्।",
  "Offers people understand": "सबैले बुझ्ने अफर",
  "Create points, discounts, punch cards, visit rewards, and item offers.":
    "अंक, छुट, पञ्च कार्ड, भ्रमण पुरस्कार र वस्तु अफर बनाउनुहोस्।",
  "A checkout built for loyalty": "वफादारीका लागि बनाइएको चेकआउट",
  "Identify members, apply value, and award the correct balance in one flow.":
    "एउटै प्रक्रियामा सदस्य पहिचान, मूल्य प्रयोग र सही मौज्दात प्रदान गर्नुहोस्।",
  "Real time": "वास्तविक समय",
  Separate: "छुट्टाछुट्टै",

  "Mero Perks for business": "व्यवसायका लागि मेरो पर्क्स",
  "Turn everyday customers into familiar faces.": "दैनिक ग्राहकलाई परिचित अनुहारमा बदल्नुहोस्।",
  "Launch a loyalty program that fits your business, from earning rules and secure checkout to quick offers, customer groups, and useful reporting.":
    "कमाइ नियम र सुरक्षित चेकआउटदेखि द्रुत अफर, ग्राहक समूह र उपयोगी प्रतिवेदनसम्म—आफ्नो व्यवसायअनुकूल वफादारी कार्यक्रम सुरु गर्नुहोस्।",
  "A neighborhood business owner welcoming regular customers":
    "नियमित ग्राहकलाई स्वागत गर्दै स्थानीय व्यवसाय मालिक",
  "plans to grow with": "वृद्धिसँगै मिल्ने योजनाहरू",
  "connected workspace": "जोडिएको कार्यस्थल",
  "reward discovery": "पुरस्कार खोज",
  "Create your business": "आफ्नो व्यवसाय बनाउनुहोस्",
  "Verify your email, business details, PAN, and location.":
    "आफ्नो इमेल, व्यवसाय विवरण, प्यान र स्थान प्रमाणित गर्नुहोस्।",
  "Set the value": "मूल्य निर्धारण गर्नुहोस्",
  "Use the guided setup to publish earning and redemption rules.":
    "कमाइ र रिडेम्प्सन नियम प्रकाशित गर्न निर्देशित सेटअप प्रयोग गर्नुहोस्।",
  "Welcome customers back": "ग्राहकलाई फेरि स्वागत गर्नुहोस्",
  "Scan members, run offers, and learn what drives another visit.":
    "सदस्य स्क्यान गर्नुहोस्, अफर चलाउनुहोस् र अर्को भ्रमणलाई के कुराले प्रेरित गर्छ बुझ्नुहोस्।",

  "Rewards marketplace": "पुरस्कार बजार",
  "A better reason to choose local.": "स्थानीय रोज्न अझ राम्रो कारण।",
  "Discover useful rewards from participating businesses before signing in, then keep every issued reward securely in one place.":
    "लग इन गर्नुअघि सहभागी व्यवसायका उपयोगी पुरस्कार पत्ता लगाउनुहोस्, अनि जारी भएका सबै पुरस्कार एकै सुरक्षित ठाउँमा राख्नुहोस्।",
  "A Mero Perks member delighting in a newly unlocked cafe reward":
    "भर्खरै खुलेको क्याफे पुरस्कारमा रमाउँदै मेरो पर्क्स सदस्य",
  availability: "उपलब्धता",
  "business offers": "व्यवसाय अफरहरू",
  "secure redemption": "सुरक्षित रिडेम्प्सन",
  "Explore openly": "खुला रूपमा खोज्नुहोस्",
  "Browse participating businesses and live offers without an account.":
    "खाता नबनाई सहभागी व्यवसाय र सक्रिय अफरहरू हेर्नुहोस्।",
  "Choose your reward": "आफ्नो पुरस्कार छान्नुहोस्",
  "Review value, eligibility, location, and expiry before redeeming.":
    "रिडिम गर्नुअघि मूल्य, योग्यता, स्थान र म्याद जाँच्नुहोस्।",
  "Show a fresh QR": "नयाँ क्यूआर देखाउनुहोस्",
  "Open the reward only when the issuing business is ready to scan it.":
    "जारी गर्ने व्यवसाय स्क्यान गर्न तयार भएपछि मात्र पुरस्कार खोल्नुहोस्।",

  "Member wallet": "सदस्य वालेट",
  "Every balance, clearly in its place.": "हरेक मौज्दात, आफ्नै ठाउँमा स्पष्ट।",
  "Your wallet brings together business-specific Reward Points, Mero Credits, purchase history, and the value available for your next visit.":
    "तपाईंको वालेटले व्यवसायअनुसारका पुरस्कार अंक, मेरो क्रेडिट, खरिद इतिहास र अर्को भ्रमणमा उपलब्ध मूल्यलाई एकै ठाउँमा ल्याउँछ।",
  "A Mero Perks member wallet with reward cards and tokens":
    "पुरस्कार कार्ड र टोकनसहित मेरो पर्क्स सदस्य वालेट",
  "member wallet": "सदस्य वालेट",
  "balance updates": "मौज्दात अद्यावधिक",
  "business points": "व्यवसाय अंक",
  Earn: "कमाउनुहोस्",
  "A verified purchase adds the correct points after redemptions are applied.":
    "रिडेम्प्सन लागू भएपछि प्रमाणित खरिदले सही अंक थप्छ।",
  Understand: "बुझ्नुहोस्",
  "See each business balance and its redemption value separately.":
    "हरेक व्यवसायको मौज्दात र त्यसको रिडेम्प्सन मूल्य छुट्टाछुट्टै हेर्नुहोस्।",
  Use: "प्रयोग गर्नुहोस्",
  "Reveal a secure member QR when the business is ready to check out.":
    "व्यवसाय चेकआउट गर्न तयार हुँदा सुरक्षित सदस्य क्यूआर देखाउनुहोस्।",

  "Mero membership tiers": "मेरो सदस्यता टियरहरू",
  "Recognition that grows across the network.": "सम्पूर्ण सञ्जालमा बढ्दै जाने पहिचान।",
  "Tier Points measure eligible activity without becoming spendable currency, moving members through Mero, Plus, Gold, and Elite.":
    "टियर अंक खर्च गर्न मिल्ने मुद्रा नबनी योग्य गतिविधि मापन गर्छन् र सदस्यलाई मेरो, प्लस, गोल्ड र एलिटमा अघि बढाउँछन्।",
  "Four premium Mero Perks tier cards progressing from Mero to Elite":
    "मेरोदेखि एलिटसम्म प्रगति देखाउने चार प्रिमियम मेरो पर्क्स टियर कार्ड",
  "membership tiers": "सदस्यता टियरहरू",
  "network status": "सञ्जाल स्थिति",
  "Tier Points redeemed": "रिडिम गरिएका टियर अंक",
  "Start at Mero": "मेरोबाट सुरु गर्नुहोस्",
  "Every verified member begins with a clear place in the program.":
    "हरेक प्रमाणित सदस्य कार्यक्रममा स्पष्ट स्थानबाट सुरु गर्छ।",
  "Build Tier Points": "टियर अंक बढाउनुहोस्",
  "Eligible purchases and platform activity move progress forward.":
    "योग्य खरिद र प्लेटफर्म गतिविधिले प्रगति अघि बढाउँछ।",
  "Reach new status": "नयाँ स्तरमा पुग्नुहोस्",
  "Plus, Gold, and Elite make recognition visible everywhere.":
    "प्लस, गोल्ड र एलिटले पहिचानलाई सबै ठाउँमा देखिने बनाउँछन्।",

  "One balance across participating places.": "सहभागी सबै ठाउँमा एउटै मौज्दात।",
  "Mero Credits are platform value earned through eligible events and accepted only where a business has enabled them.":
    "मेरो क्रेडिट योग्य गतिविधिबाट कमाइने प्लेटफर्म मूल्य हो र व्यवसायले सक्षम गरेको ठाउँमा मात्र स्वीकारिन्छ।",
  "Mero Credits connecting one member wallet to participating places":
    "एउटा सदस्य वालेटलाई सहभागी ठाउँहरूसँग जोड्दै मेरो क्रेडिट",
  "platform balance": "प्लेटफर्म मौज्दात",
  "earning events": "कमाइ गतिविधि",
  "acceptance rules": "स्वीकृति नियम",
  "Earn credits": "क्रेडिट कमाउनुहोस्",
  "Active platform rules award credits for qualifying events.":
    "सक्रिय प्लेटफर्म नियमले योग्य गतिविधिका लागि क्रेडिट दिन्छ।",
  "Find acceptance": "स्वीकार गर्ने ठाउँ खोज्नुहोस्",
  "Your wallet shows participating businesses and usable value.":
    "तपाईंको वालेटले सहभागी व्यवसाय र प्रयोगयोग्य मूल्य देखाउँछ।",
  "Apply at checkout": "चेकआउटमा लागू गर्नुहोस्",
  "Choose all or part of your balance before the final amount is calculated.":
    "अन्तिम रकम गणना हुनुअघि आफ्नो मौज्दातको सबै वा केही भाग छान्नुहोस्।",

  "Quick offers": "द्रुत अफरहरू",
  "Launch the kind of offer customers instantly understand.":
    "ग्राहकले तुरुन्तै बुझ्ने किसिमको अफर सुरु गर्नुहोस्।",
  "Publish simple discounts, buy-one-get-one offers, visit rewards, item-specific benefits, and digital punch cards with clear limits.":
    "स्पष्ट सीमासहित सरल छुट, एउटा किन्दा अर्को निःशुल्क, भ्रमण पुरस्कार, वस्तु-विशेष लाभ र डिजिटल पञ्च कार्ड प्रकाशित गर्नुहोस्।",
  "Cafe owners photographing an item for a new quick offer":
    "नयाँ द्रुत अफरका लागि वस्तुको तस्बिर खिच्दै क्याफे मालिक",
  "offer mechanics": "अफर संरचना",
  "inventory targeting": "इन्भेन्टरी लक्ष्यीकरण",
  "publish workflow": "प्रकाशन प्रक्रिया",
  "Choose a mechanic": "अफर प्रकार छान्नुहोस्",
  "Start with a proven offer structure that fits your objective.":
    "आफ्नो उद्देश्यअनुकूल प्रमाणित अफर संरचनाबाट सुरु गर्नुहोस्।",
  "Define eligibility": "योग्यता परिभाषित गर्नुहोस्",
  "Select items, visits, dates, locations, tiers, and limits.":
    "वस्तु, भ्रमण, मिति, स्थान, टियर र सीमा छान्नुहोस्।",
  "Publish with confidence": "विश्वस्त भएर प्रकाशित गर्नुहोस्",
  "Customers see the offer and its exact terms in the marketplace.":
    "ग्राहकले बजारमा अफर र त्यसका ठ्याक्कै सर्तहरू देख्छन्।",

  "Checkout & redemption": "चेकआउट र रिडेम्प्सन",
  "One scan. One clear transaction.": "एउटा स्क्यान। एउटा स्पष्ट कारोबार।",
  "Identify a member, see business-specific balances, apply points or Mero Credits, and calculate earnings only on the amount actually paid.":
    "सदस्य पहिचान गर्नुहोस्, व्यवसायअनुसारको मौज्दात हेर्नुहोस्, अंक वा मेरो क्रेडिट लागू गर्नुहोस् र वास्तवमै तिरेको रकममा मात्र कमाइ गणना गर्नुहोस्।",
  "A business owner securely scanning a member QR at checkout":
    "चेकआउटमा सदस्य क्यूआर सुरक्षित रूपमा स्क्यान गर्दै व्यवसाय मालिक",
  "checkout flow": "चेकआउट प्रक्रिया",
  "secure identification": "सुरक्षित पहिचान",
  "Enter the purchase": "खरिद रकम प्रविष्ट गर्नुहोस्",
  "Start with the total and select the correct business location.":
    "कुल रकमबाट सुरु गरी सही व्यवसाय स्थान छान्नुहोस्।",
  "Scan the member": "सदस्य स्क्यान गर्नुहोस्",
  "See member identity, tier, points, credits, and eligible rewards.":
    "सदस्यको पहिचान, टियर, अंक, क्रेडिट र योग्य पुरस्कार हेर्नुहोस्।",
  "Complete once": "एकै पटक पूरा गर्नुहोस्",
  "Redemptions, payment, earnings, and receipt history update together.":
    "रिडेम्प्सन, भुक्तानी, कमाइ र रसिद इतिहास एकसाथ अद्यावधिक हुन्छन्।",

  "Customer insights": "ग्राहक अन्तर्दृष्टि",
  "See the relationships behind the transactions.": "कारोबारपछाडिका सम्बन्ध बुझ्नुहोस्।",
  "Follow return activity, reward demand, liabilities, campaigns, and member segments without losing the audit trail behind each result.":
    "हरेक नतिजाको लेखापरीक्षण विवरण सुरक्षित राख्दै पुनःभ्रमण, पुरस्कार माग, दायित्व, अभियान र सदस्य समूह अनुगमन गर्नुहोस्।",
  "A cafe team reviewing Mero Perks customer insights":
    "मेरो पर्क्स ग्राहक अन्तर्दृष्टि समीक्षा गर्दै क्याफे टोली",
  dashboard: "ड्यासबोर्ड",
  activity: "गतिविधि",
  segments: "समूहहरू",
  "Measure activity": "गतिविधि मापन गर्नुहोस्",
  "Review purchases, redemptions, points, and offer performance.":
    "खरिद, रिडेम्प्सन, अंक र अफरको प्रदर्शन समीक्षा गर्नुहोस्।",
  "Build a segment": "समूह बनाउनुहोस्",
  "Group customers using meaningful behavior and account signals.":
    "अर्थपूर्ण व्यवहार र खाता संकेतका आधारमा ग्राहक समूह बनाउनुहोस्।",
  "Act with purpose": "उद्देश्यसहित कार्य गर्नुहोस्",
  "Use the segment in a campaign, automation, or next offer.":
    "समूहलाई अभियान, स्वचालन वा अर्को अफरमा प्रयोग गर्नुहोस्।",

  "Mero Perks for retail": "खुद्रा व्यवसायका लागि मेरो पर्क्स",
  "Reward the purchase—and the return visit.": "खरिद र पुनःभ्रमण दुवैलाई पुरस्कृत गर्नुहोस्।",
  "Connect offers to selected products or brands, redeem business points at checkout, and make every condition clear before customers arrive.":
    "अफरलाई छानिएका उत्पादन वा ब्रान्डसँग जोड्नुहोस्, चेकआउटमा व्यवसाय अंक रिडिम गर्नुहोस् र ग्राहक आउनुअघि हरेक सर्त स्पष्ट बनाउनुहोस्।",
  "Retail shopping through Mero Perks": "मेरो पर्क्समार्फत खुद्रा किनमेल",
  "level targeting": "स्तर लक्ष्यीकरण",
  "location support": "स्थान समर्थन",
  "reward terms": "पुरस्कार सर्तहरू",
  "Add inventory": "इन्भेन्टरी थप्नुहोस्",
  "Create the products, categories, and brands used in offers.":
    "अफरमा प्रयोग हुने उत्पादन, श्रेणी र ब्रान्ड बनाउनुहोस्।",
  "Target the offer": "अफर लक्षित गर्नुहोस्",
  "Limit benefits to exactly the items or collections intended.":
    "लाभलाई चाहिएका वस्तु वा सङ्कलनमा मात्र सीमित गर्नुहोस्।",
  "Confirm eligibility and calculate the correct customer payment.":
    "योग्यता पुष्टि गरी ग्राहकले तिर्नुपर्ने सही रकम गणना गर्नुहोस्।",

  "For cafes & restaurants": "क्याफे र रेस्टुरेन्टका लागि",
  "Make the next order feel closer.": "अर्को अर्डरलाई अझ नजिक महसुस गराउनुहोस्।",
  "Run coffee punch cards, visit rewards, complimentary items, and point earning that remains easy for staff during a busy service.":
    "व्यस्त सेवामा पनि कर्मचारीका लागि सहज रहने कफी पञ्च कार्ड, भ्रमण पुरस्कार, निःशुल्क वस्तु र अंक कमाइ सञ्चालन गर्नुहोस्।",
  "Food and beverage rewards through Mero Perks": "मेरो पर्क्समार्फत खाना तथा पेय पुरस्कार",
  "card mechanics": "कार्ड संरचना",
  "staff checkout": "कर्मचारी चेकआउट",
  "visit focus": "भ्रमण केन्द्रित",
  "Choose the habit": "बानी छान्नुहोस्",
  "Reward visits, specific items, spend, or a combination.":
    "भ्रमण, निश्चित वस्तु, खर्च वा तिनको संयोजनलाई पुरस्कृत गर्नुहोस्।",
  "Set the milestone": "लक्ष्य निर्धारण गर्नुहोस्",
  "Define how many qualifying purchases unlock the benefit.":
    "कति योग्य खरिदपछि लाभ खुल्छ परिभाषित गर्नुहोस्।",
  "Issue automatically": "स्वतः जारी गर्नुहोस्",
  "The earned coupon appears when the verified milestone is reached.":
    "प्रमाणित लक्ष्य पूरा भएपछि कमाइएको कुपन स्वतः देखिन्छ।",

  "For hotels & stays": "होटल र बसाइका लागि",
  "Recognize guests beyond a single stay.": "एउटै बसाइभन्दा पर पनि पाहुनालाई पहिचान दिनुहोस्।",
  "Create location-aware benefits, tier recognition, and rewards that connect eligible visits across your hospitality business.":
    "आफ्नो आतिथ्य व्यवसायभरिका योग्य भ्रमण जोड्ने स्थानअनुकूल लाभ, टियर पहिचान र पुरस्कार बनाउनुहोस्।",
  "Hotel stay rewards through Mero Perks": "मेरो पर्क्समार्फत होटल बसाइ पुरस्कार",
  recognition: "पहिचान",
  "based rewards": "आधारित पुरस्कार",
  "Define the stay": "बसाइ परिभाषित गर्नुहोस्",
  "Connect earning rules to eligible, completed guest transactions.":
    "कमाइ नियमलाई योग्य र पूरा भएका पाहुना कारोबारसँग जोड्नुहोस्।",
  "Recognize status": "स्थिति पहिचान गर्नुहोस्",
  "See the member tier and applicable benefits at service time.":
    "सेवाको समयमा सदस्य टियर र लागू हुने लाभ हेर्नुहोस्।",
  "Invite the return": "फेरि आउन निम्त्याउनुहोस्",
  "Issue a relevant offer with a clear validity period and location scope.":
    "स्पष्ट वैधता अवधि र स्थान सीमासहित सान्दर्भिक अफर जारी गर्नुहोस्।",

  "Built for small business": "साना व्यवसायका लागि बनाइएको",
  "Start with loyalty you can actually run.": "व्यवहारमै चलाउन सकिने वफादारीबाट सुरु गर्नुहोस्।",
  "Use a guided setup, practical offer templates, simple member scanning, and a Free plan that makes the first step easy.":
    "पहिलो कदम सहज बनाउने निर्देशित सेटअप, व्यावहारिक अफर टेम्प्लेट, सरल सदस्य स्क्यान र निःशुल्क योजना प्रयोग गर्नुहोस्।",
  "A neighborhood kirana owner greeting a familiar customer":
    "परिचित ग्राहकलाई अभिवादन गर्दै स्थानीय किराना मालिक",
  "plan available": "योजना उपलब्ध",
  setup: "सेटअप",
  "business tools": "व्यवसाय उपकरण",
  "Join the network": "सञ्जालमा जोडिनुहोस्",
  "Create and verify a business account from web or mobile.":
    "वेब वा मोबाइलबाट व्यवसाय खाता बनाएर प्रमाणित गर्नुहोस्।",
  "Follow the setup": "सेटअप पछ्याउनुहोस्",
  "The wizard builds earning, redemption, and your first offer.":
    "विजार्डले कमाइ, रिडेम्प्सन र तपाईंको पहिलो अफर तयार गर्छ।",
  "Serve from your phone": "फोनबाट सेवा दिनुहोस्",
  "Scan members and manage the essentials without a separate terminal.":
    "छुट्टै टर्मिनलविना सदस्य स्क्यान गरी आवश्यक काम व्यवस्थापन गर्नुहोस्।",

  "Join once. Earn clearly. Use securely.":
    "एकपटक जोडिनुहोस्। स्पष्ट कमाउनुहोस्। सुरक्षित प्रयोग गर्नुहोस्।",
  "Mero Perks keeps business points, platform credits, tier progress, rewards, and purchase history understandable from the first visit.":
    "मेरो पर्क्सले पहिलो भ्रमणदेखि नै व्यवसाय अंक, प्लेटफर्म क्रेडिट, टियर प्रगति, पुरस्कार र खरिद इतिहास बुझ्न सजिलो बनाउँछ।",
  "A customer presenting a secure Mero Perks QR at a cafe checkout":
    "क्याफे चेकआउटमा सुरक्षित मेरो पर्क्स क्यूआर देखाउँदै ग्राहक",
  "member account": "सदस्य खाता",
  "digital card": "डिजिटल कार्ड",
  "eligible visit": "योग्य भ्रमण",
  "Create your account": "आफ्नो खाता बनाउनुहोस्",
  "Verify your email and receive a secure Mero Perks member identity.":
    "आफ्नो इमेल प्रमाणित गरी सुरक्षित मेरो पर्क्स सदस्य पहिचान प्राप्त गर्नुहोस्।",
  "Visit a partner": "साझेदारकहाँ जानुहोस्",
  "Show a fresh member QR when staff are ready to record the purchase.":
    "कर्मचारी खरिद रेकर्ड गर्न तयार हुँदा नयाँ सदस्य क्यूआर देखाउनुहोस्।",
  "Enjoy the value": "मूल्यको लाभ लिनुहोस्",
  "Track points, use rewards, and grow your tier across the network.":
    "अंक अनुगमन गर्नुहोस्, पुरस्कार प्रयोग गर्नुहोस् र सञ्जालभरि आफ्नो टियर बढाउनुहोस्।",

  "Member benefits": "सदस्य लाभहरू",
  "More than points. A better view of loyalty.": "अंकभन्दा धेरै। वफादारीको अझ राम्रो अनुभव।",
  "Discover offers publicly, manage separate business balances, use platform credits, and grow a recognizable tier with one account.":
    "सार्वजनिक रूपमा अफर पत्ता लगाउनुहोस्, व्यवसायका छुट्टाछुट्टै मौज्दात व्यवस्थापन गर्नुहोस्, प्लेटफर्म क्रेडिट प्रयोग गर्नुहोस् र एउटै खाताबाट पहिचानयोग्य टियर बढाउनुहोस्।",
  "A Nepali family enjoying everyday Mero Perks member benefits together":
    "दैनिक मेरो पर्क्स सदस्य लाभ सँगै उपयोग गर्दै नेपाली परिवार",
  "tier levels": "टियर स्तरहरू",
  "secure card": "सुरक्षित कार्ड",
  "rewarding places": "पुरस्कार दिने ठाउँहरू",
  "Find participating businesses and useful live offers.":
    "सहभागी व्यवसाय र उपयोगी सक्रिय अफरहरू खोज्नुहोस्।",
  "Carry one card": "एउटै कार्ड बोक्नुहोस्",
  "Use the same secure member identity across the Mero Perks network.":
    "मेरो पर्क्स सञ्जालभरि एउटै सुरक्षित सदस्य पहिचान प्रयोग गर्नुहोस्।",
  "Stay informed": "जानकारीमा रहनुहोस्",
  "Notifications and history keep rewards, purchases, and progress visible.":
    "सूचना र इतिहासले पुरस्कार, खरिद र प्रगति देखाइराख्छ।",

  "Business pricing": "व्यवसाय मूल्य योजना",
  "Start free. Add more when loyalty grows.": "निःशुल्क सुरु गर्नुहोस्। वफादारी बढेपछि थप्नुहोस्।",
  "Choose a plan around the tools and scale your business needs today. Your subscription choice is visible during signup and in your account.":
    "आज तपाईंको व्यवसायलाई चाहिने उपकरण र आकारअनुसार योजना छान्नुहोस्। सदस्यता छनोट साइनअप र खातामा देखिन्छ।",
  "Three Mero Perks business plans represented by ascending service plaques":
    "बढ्दो सेवास्तरका पट्टिकाले देखाएका तीन मेरो पर्क्स व्यवसाय योजना",
  "Basic plan": "बेसिक योजना",
  "Pro monthly": "प्रो मासिक",
  "Master monthly": "मास्टर मासिक",
  Basic: "बेसिक",
  Pro: "प्रो",
  Master: "मास्टर",
  "Essential loyalty tools for a small business getting started.":
    "सुरु गर्दै गरेको साना व्यवसायका लागि आवश्यक वफादारी उपकरण।",
  "Expanded offers, campaigns, insights, and operating capacity.":
    "विस्तारित अफर, अभियान, अन्तर्दृष्टि र सञ्चालन क्षमता।",
  "The fullest feature set for businesses managing more locations and growth.":
    "धेरै स्थान र वृद्धि व्यवस्थापन गर्ने व्यवसायका लागि सबैभन्दा पूर्ण सुविधा समूह।",
  "Plans for every stage": "हरेक चरणका लागि योजना",
  "Choose the workspace your business needs.": "आफ्नो व्यवसायलाई चाहिने कार्यस्थल छान्नुहोस्।",
  "Annual billing is shown alongside monthly pricing so the full commitment is always clear.":
    "कुल प्रतिबद्धता सधैं स्पष्ट रहोस् भनेर मासिक मूल्यसँगै वार्षिक बिलिङ देखाइएको छ।",
  "Most popular": "सबैभन्दा लोकप्रिय",
  Free: "निःशुल्क",
  "No subscription fee": "सदस्यता शुल्क छैन",
  "per month": "प्रति महिना",
  "billed yearly": "वार्षिक बिलिङ",
  Choose: "छान्नुहोस्",
  "Start rewarding regular customers at no cost.":
    "कुनै शुल्कविना नियमित ग्राहकलाई पुरस्कृत गर्न सुरु गर्नुहोस्।",
  "Grow repeat business with targeted loyalty tools.":
    "लक्षित वफादारी उपकरणबाट दोहोरिने कारोबार बढाउनुहोस्।",
  "Run a complete multi-location loyalty operation.": "पूर्ण बहु-स्थान वफादारी सञ्चालन चलाउनुहोस्।",
  "Reward Point earning and redemption rules": "पुरस्कार अंक कमाइ र रिडेम्प्सन नियम",
  "Digital visit and purchase punch cards": "डिजिटल भ्रमण र खरिद पञ्च कार्ड",
  "Up to 5 active Quick Offers": "५ वटासम्म सक्रिय द्रुत अफर",
  "1 business location and 2 staff accounts": "१ व्यवसाय स्थान र २ कर्मचारी खाता",
  "100 inventory items and 500 members": "१०० इन्भेन्टरी वस्तु र ५०० सदस्य",
  "Basic checkout and performance summary": "आधारभूत चेकआउट र प्रदर्शन सारांश",
  "Everything in Basic": "बेसिकका सबै सुविधा",
  "Mero Credits acceptance": "मेरो क्रेडिट स्वीकृति",
  "Customer segments and targeted campaigns": "ग्राहक समूह र लक्षित अभियान",
  "Up to 100 active Quick Offers": "१०० वटासम्म सक्रिय द्रुत अफर",
  "5 locations and 15 staff accounts": "५ स्थान र १५ कर्मचारी खाता",
  "2,500 inventory items and 5,000 members": "२,५०० इन्भेन्टरी वस्तु र ५,००० सदस्य",
  "Advanced loyalty analytics": "उन्नत वफादारी विश्लेषण",
  "Everything in Pro": "प्रोका सबै सुविधा",
  "Unlimited locations, members, offers, and inventory": "असीमित स्थान, सदस्य, अफर र इन्भेन्टरी",
  "Unlimited staff accounts and campaigns": "असीमित कर्मचारी खाता र अभियान",
  "Lifecycle automations": "जीवनचक्र स्वचालन",
  "Data exports and full reporting": "डेटा निर्यात र पूर्ण प्रतिवेदन",
  "Priority platform support": "प्राथमिकता प्लेटफर्म सहयोग",

  "Frequently asked questions": "बारम्बार सोधिने प्रश्नहरू",
  "Straight answers before you get started.": "सुरु गर्नुअघि स्पष्ट जवाफ।",
  "Learn how accounts, points, tiers, QR security, business approval, and subscriptions work across Mero Perks.":
    "मेरो पर्क्समा खाता, अंक, टियर, क्यूआर सुरक्षा, व्यवसाय स्वीकृति र सदस्यता कसरी काम गर्छन् जान्नुहोस्।",
  "A Mero Perks support specialist helping a small-business owner":
    "साना व्यवसाय मालिकलाई सहयोग गर्दै मेरो पर्क्स सहयोग विशेषज्ञ",
  "customer signup": "ग्राहक साइनअप",
  "email accounts": "इमेल खाताहरू",
  "when needed": "आवश्यक पर्दा",
  "Can one email hold both account types?": "एउटै इमेलमा दुवै प्रकारका खाता हुन सक्छन्?",
  "Yes. A customer account and a Business Owner account may use the same email, with separate credentials and roles.":
    "हो। ग्राहक खाता र व्यवसाय मालिक खाताले छुट्टाछुट्टै प्रमाणपत्र र भूमिकासहित एउटै इमेल प्रयोग गर्न सक्छन्।",
  "Can points move between businesses?": "अंक एउटा व्यवसायबाट अर्कोमा सार्न मिल्छ?",
  "No. Reward Points stay with the business that issued them; Mero Credits are the platform-wide balance.":
    "मिल्दैन। पुरस्कार अंक जारी गर्ने व्यवसायमै रहन्छन्; मेरो क्रेडिट प्लेटफर्मभरि प्रयोग हुने मौज्दात हो।",
  "How are redemptions protected?": "रिडेम्प्सन कसरी सुरक्षित गरिन्छ?",
  "Member and reward QR codes are short-lived and checked by the server before any transaction is accepted.":
    "सदस्य र पुरस्कार क्यूआर छोटो समयका लागि मात्र मान्य हुन्छन् र कारोबार स्वीकार हुनुअघि सर्भरले जाँच गर्छ।",
  "Helpful details": "उपयोगी विवरण",
  "What members and businesses ask most.": "सदस्य र व्यवसायले सबैभन्दा धेरै सोध्ने कुरा।",
  "Is a customer account free?": "ग्राहक खाता निःशुल्क हो?",
  "Yes. Customers can join Mero Perks, browse rewards, and use their member wallet without a subscription fee.":
    "हो। ग्राहक सदस्यता शुल्कविना मेरो पर्क्समा जोडिन, पुरस्कार हेर्न र सदस्य वालेट प्रयोग गर्न सक्छन्।",
  "Can I use the same email for customer and Business Owner accounts?":
    "ग्राहक र व्यवसाय मालिक खाताका लागि एउटै इमेल प्रयोग गर्न सक्छु?",
  "Yes. The two account types are separate, so the same email may be used once for each role.":
    "हो। दुई खाता प्रकार अलग भएकाले एउटै इमेल प्रत्येक भूमिकाका लागि एकपटक प्रयोग गर्न सकिन्छ।",
  "Can Reward Points be used at another business?":
    "पुरस्कार अंक अर्को व्यवसायमा प्रयोग गर्न मिल्छ?",
  "No. Reward Points belong to the issuing business. Mero Credits are the separate platform-wide balance accepted by enabled businesses.":
    "मिल्दैन। पुरस्कार अंक जारी गर्ने व्यवसायकै हुन्छन्। मेरो क्रेडिट सक्षम व्यवसायले स्वीकार गर्ने छुट्टै प्लेटफर्मव्यापी मौज्दात हो।",
  "Does a business become active immediately?": "व्यवसाय तुरुन्तै सक्रिय हुन्छ?",
  "A Business Owner verifies their email, then the application is reviewed and approved by a Super Admin before the business can go live.":
    "व्यवसाय मालिकले इमेल प्रमाणित गरेपछि सुपर एडमिनले आवेदन समीक्षा र स्वीकृत गरेपछि मात्र व्यवसाय लाइभ हुन्छ।",
  "What happens if a QR is copied?": "क्यूआर प्रतिलिपि भए के हुन्छ?",
  "Member and reward QR codes expire quickly and are validated on the server. A reward redemption cannot be accepted twice.":
    "सदस्य र पुरस्कार क्यूआर छिट्टै म्याद सकिन्छन् र सर्भरमा प्रमाणीकरण हुन्छ। एउटै पुरस्कार रिडेम्प्सन दुईपटक स्वीकार हुँदैन।",

  Flexible: "लचिलो",
  Visible: "दृश्य",
  Live: "प्रत्यक्ष",
  Local: "स्थानीय",
  Item: "वस्तु",
  Fast: "छिटो",
  Audited: "लेखापरीक्षित",
  Useful: "उपयोगी",
  Multi: "बहु",
  Clear: "स्पष्ट",
  Punch: "पञ्च",
  Repeat: "पुनःभ्रमण",
  Tier: "टियर",
  Stay: "बसाइ",
  Guided: "निर्देशित",
  Mobile: "मोबाइल",
  Every: "हरेक",
  Many: "धेरै",
  Verified: "प्रमाणित",
  Support: "सहयोग",
};
